import React from 'react'
import { number } from 'prop-types'

function FlexibleIterations({ width = 16, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.19056 17.3332C5.77151 17.3332 5.41291 17.1841 5.11475 16.8859C4.81659 16.5878 4.66726 16.2289
        4.66675 15.8094V8.19031C4.66675 7.77127 4.81608 7.41266 5.11475 7.1145C5.41341 6.81634 5.77202 6.66701
        6.19056 6.6665H13.8096C14.2287 6.6665 14.5875 6.81584 14.8862 7.1145C15.1848 7.41317 15.3339 7.77177 15.3334
        8.19031V15.8094C15.3334 16.2284 15.1843 16.5873 14.8862 16.8859C14.588 17.1846 14.2292 17.3337 13.8096
        17.3332H6.19056ZM8.59163 12.5113L9.53728 13.9024L10.9558 11.8289C11.0503 11.6889 11.1764 11.6189 11.334
        11.6189C11.4916 11.6189 11.6177 11.6889 11.7123 11.8289L13.2253 14.1123C13.3514 14.2873 13.3672 14.471 13.2726
        14.6635C13.1781 14.856 13.0362 14.9522 12.8471 14.9522H7.17314C6.98338 14.9522 6.83744 14.856 6.73531
        14.6635C6.63317 14.471 6.64515 14.2873 6.77124 14.1123L7.8351 12.5375C7.92967 12.3982 8.05576 12.3241 8.21337
        12.315C8.37097 12.3059 8.49706 12.3713 8.59163 12.5113ZM3.66675 15.9998C3.38897 15.9998 3.15297 15.9025 2.95875
        15.7078C2.76453 15.5132 2.66719 15.2772 2.66675 14.9998V8.99984C2.66675 8.72206 2.76408 8.48584 2.95875
        8.29117C3.15341 8.0965 3.38941 7.99939 3.66675 7.99984V15.9998ZM1.66675 15.3332C1.38897 15.3332 1.15297 15.2358
        0.958748 15.0412C0.764526 14.8465 0.667192 14.6105 0.666748 14.3332V9.6665C0.666748 9.38873 0.764081 9.1525
        0.958748 8.95784C1.15341 8.76317 1.38941 8.66606 1.66675 8.6665V15.3332Z"
        fill="#A7F6FC"
      />
    </svg>
  )
}

FlexibleIterations.propTypes = {
  width: number,
  height: number,
}

export default FlexibleIterations
